import React from 'react';
import { cn } from './cn';
import { aileToplami, hexToRgba } from '../../lib/dersler';

// Ders sekme/pill barı. Aktif ders vurgulu; pasif ("yakında") dersler soluk
// ve tıklanamaz. Her pill: ikon + ad + soru sayısı rozeti.
// `seciliIsaret`: seçili pill'e "✓ " öneki (basım ekranı seçim stili, 2026-09-03);
// varsayılan kapalı — diğer ekranlar değişmez.
// `aktifKeys`: çoklu seçim (basım genel deneme, 2026-09-03) — verilirse `aktifKey` yerine geçer.
export function DersPills({ aileler, aktifKey, aktifKeys = null, onSec, ozet, maarif, seciliIsaret = false }) {
  return (
    // Eşit genişlikli ızgara: pill'ler sütun hizasında durur, sağ kenar düzensiz kalmaz
    // (geniş ekranda 5 sütun → 10 ders iki düzgün satır).
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5">
      {aileler.map((aile) => {
        const secili = Array.isArray(aktifKeys) ? aktifKeys.includes(aile.key) : aile.key === aktifKey;
        const pasif = !aile.aktif;
        const toplam = aileToplami(aile, ozet);
        // Maarif (2028+) alt-rozeti — veri-güdümlü (2026-07-08): hangi ders
        // ailesinin gerçekten Maarif satırı varsa (matematik/kimya/biyoloji/
        // fizik) orada gösterilir; toplam kendi ailesinin sayısına dahildir.
        const maarifSayi = aileToplami(aile, maarif);

        return (
          <button
            key={aile.key}
            type="button"
            disabled={pasif}
            onClick={() => !pasif && onSec(aile.key)}
            aria-pressed={secili}
            title={pasif ? `${aile.label} — yakında` : aile.label}
            className={cn(
              'group relative flex min-w-0 items-center gap-2 rounded-xl border transition-all',
              'pl-2 pr-2.5 py-1.5 select-none',
              pasif
                ? 'border-dashed border-gray-200 bg-gray-50/60 cursor-not-allowed'
                : secili
                ? 'border-l-4 border-blue-500 bg-blue-50 text-slate-900 shadow-sm'
                : 'bg-white border-slate-200 text-slate-700 hover:border-blue-200 hover:bg-slate-50 cursor-pointer'
            )}
          >
            {/* İkon kutusu */}
            <span
              className={cn(
                'flex shrink-0 items-center justify-center w-7 h-7 rounded-lg text-base leading-none',
                pasif && 'grayscale opacity-50'
              )}
              style={
                secili && !pasif
                  ? { backgroundColor: hexToRgba(aile.renk, 0.16) }
                  : !pasif
                  ? { backgroundColor: hexToRgba(aile.renk, 0.12) }
                  : undefined
              }
            >
              {aile.ikon}
            </span>

            {/* Ad */}
            <span
              className={cn(
                'min-w-0 truncate text-sm font-bold',
                pasif ? 'text-gray-400' : secili ? 'text-slate-900' : 'text-gray-700'
              )}
            >
              {seciliIsaret && secili && !pasif ? '✓ ' : ''}{aile.label}
            </span>

            {/* Sayı rozeti / yakında */}
            {pasif ? (
              <span className="ml-auto shrink-0 text-[10px] font-medium text-gray-400 uppercase tracking-wide">
                yakında
              </span>
            ) : (
              <span
                className="ml-auto shrink-0 tabular-nums text-xs font-semibold text-slate-500"
                title={`${aile.label}: toplam ${toplam} soru`}
              >
                {toplam}
              </span>
            )}

            {/* Maarif alt-rozeti (veri-güdümlü — Maarif satırı olan her aile).
                Kompakt: yalnız ✦ + sayı; "Maarif" kelimesi yer kazanmak için
                düşürüldü (tam metin title tooltip'inde). */}
            {!pasif && maarifSayi > 0 && (
              <span
                className="hidden sm:inline-flex shrink-0 items-center rounded-full bg-emerald-50 px-1.5 py-0.5 text-[11px] font-semibold tabular-nums leading-none text-emerald-700"
                title={`${maarifSayi} Maarif (2028+) sorusu — ${aile.label} toplamına dahildir`}
              >
                ✦ {maarifSayi}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default DersPills;
